const getJSValue = {
    True: true,
    False: false,
    All: 'All'
};

const setJSValue = {
    true: 'True',
    false: 'False',
    All: 'All'
};

export const setEnum = value => setJSValue[value];
export const getEnum = value => getJSValue[value];
